import { render, staticRenderFns } from "./newsPage06.vue?vue&type=template&id=73ddd41d&scoped=true&"
import script from "./newsPage06.vue?vue&type=script&lang=js&"
export * from "./newsPage06.vue?vue&type=script&lang=js&"
import style0 from "./newsPage06.vue?vue&type=style&index=0&id=73ddd41d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ddd41d",
  null
  
)

export default component.exports